import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

import Template from './templateSelector/Template';

import './TemplateSelector.scss';

class TemplateSelector extends Component {
  render() {
    const {
      selectATemplate,
      template_id,
      templates,
      hideTemplateSelector
    } = this.props.templateStore;
    const templateButtons = templates.map((template, index) => {
      return (
        <Template
          id={template._id}
          key={template._id}
          occupation={template.occupation}
          persona_image={template.persona_image}
          selectTemplate={selectATemplate}
          template_id={template_id}
        />
      );
    });
    return (
      <div className="template-selector">
        <button type="button" className="close" aria-label="close" onClick={hideTemplateSelector}>
          <span aria-hidden="true">&times;</span>
        </button>
        <h1>Create your own User Personas by building off one of our templates</h1>
        <small>Click into a field to edit. Your changes are autosaved to PersonaGenerator as you make them.</small>
        <div className="template-container">
          {templateButtons}
        </div>
      </div>
    );
  }
}

export default inject('templateStore')(observer(TemplateSelector));



// WEBPACK FOOTER //
// ./client/pages/persona/TemplateSelector.jsx